import { render, staticRenderFns } from "./ClicHint.vue?vue&type=template&id=7055f3a9&scoped=true&"
import script from "./ClicHint.vue?vue&type=script&lang=js&"
export * from "./ClicHint.vue?vue&type=script&lang=js&"
import style0 from "./ClicHint.vue?vue&type=style&index=0&id=7055f3a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7055f3a9",
  null
  
)

export default component.exports